import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n';

const sections = [
    {
        title: '1. Thông tin thu thập',
        content: 'Chúng tôi chỉ thu thập các thông tin cần thiết: email liên hệ, thông tin doanh nghiệp, yêu cầu dự án. Không bán hoặc chia sẻ dữ liệu cho bên thứ ba ngoài mục đích thực hiện dịch vụ.'
    },
    {
        title: '2. Mục đích sử dụng',
        content: 'Dùng để tư vấn, triển khai dịch vụ, cải thiện trải nghiệm, gửi thông báo nâng cấp hoặc bảo trì quan trọng.'
    },
    {
        title: '3. Bảo mật & lưu trữ',
        content: 'Máy chủ bảo mật, giới hạn truy cập nội bộ, áp dụng SSL, cập nhật vá lỗi định kỳ. Dữ liệu nhạy cảm (nếu có) được mã hoá.'
    },
    {
        title: '4. Cookie & tracking',
        content: 'Chỉ sử dụng cookie chức năng & phân tích hiệu suất ẩn danh nhằm tối ưu tốc độ và trải nghiệm. Bạn có thể tắt qua trình duyệt.'
    },
    {
        title: '5. Quyền của bạn',
        content: 'Yêu cầu chỉnh sửa, xoá dữ liệu hoặc ngừng nhận thông tin bất cứ lúc nào qua email hỗ trợ.'
    }
];

const PrivacyPolicy = () => {
    const { language, t } = useLanguage();
    const localizedSections = language === 'vi' ? sections : [
        { title: '1. Information we collect', content: 'We collect only what is needed: contact email, business information, and project requirements. We do not sell or share data outside the purpose of delivering the service.' },
        { title: '2. How we use it', content: 'To provide consultation, deliver services, improve the experience, and send important upgrade or maintenance notices.' },
        { title: '3. Security and storage', content: 'We use secure servers, limited internal access, SSL, and regular security updates. Sensitive data, when applicable, is encrypted.' },
        { title: '4. Cookies and tracking', content: 'We use functional cookies and anonymous performance analytics to improve speed and experience. You can disable them in your browser.' },
        { title: '5. Your rights', content: 'You can request correction, deletion, or opt out of communications at any time by contacting support.' },
    ];
    return (
        <section className="pt-32 pb-24 bg-white min-h-screen" id="privacy-policy">
            <div className="container mx-auto px-4 max-w-4xl">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="mb-12">
                    <h1 className="text-4xl font-extrabold mb-4 text-gray-900">{t('privacy')}</h1>
                    <p className="text-gray-600 leading-relaxed">{language === 'vi' ? 'Chúng tôi cam kết bảo vệ dữ liệu người dùng và duy trì minh bạch trong cách thu thập & xử lý thông tin.' : 'We protect user data and stay transparent about how information is collected and handled.'}</p>
                </motion.div>

                <div className="space-y-8 mb-12">
                    {localizedSections.map((s, i) => (
                        <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }} className="border-l-4 border-primary-500 pl-5">
                            <h2 className="text-xl font-semibold mb-2">{s.title}</h2>
                            <p className="text-gray-600 leading-relaxed text-sm md:text-base">{s.content}</p>
                        </motion.div>
                    ))}
                </div>

                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                    <p className="text-sm text-gray-600 mb-3">{language === 'vi' ? 'Nếu có câu hỏi về bảo mật hoặc yêu cầu dữ liệu, vui lòng liên hệ:' : 'For privacy questions or data requests, please contact:'}</p>
                    <p className="font-medium text-gray-800">Email: privacy@wordpresspro.vn</p>
                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicy;
